<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <scheme-form :itemId="id" formType="Edit" subTitle="Edit Scheme"></scheme-form>
      </div>
    </div>
  </div>
</template>

<script>
import SchemeForm from "@/views/scheme/components/Form.vue";

export default {
  name: "edit-users",
  data(){
    return {
      id : this.$route.params.id
    }
  },
  components: {
    SchemeForm,
  }
};
</script>